module.exports = __webpack_public_path__ + "img/bd.43a7ac72.svg";